import React, { createContext, useContext, useEffect, useState } from 'react'
import {User, AuthContextType } from '../interfaces/auth.insterface'
import api, { login as apiLogin, logout as apiLogout, setAuthToken } from '../services/api';
import {getSubscribeCurrentPlan} from "../services/subcriptions";

const AuthContext = createContext<AuthContextType>({
  isAuth: false,
  user: null,
  login: async () => {},
  logout: async () => {},
  checkAuth: async () => {},
});

export const LoginProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAuth, setIsAuth] = useState(false);

  // Verificar autenticación al cargar
  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email: string, password: string) => {
    try {
      const response = await apiLogin(email, password);
      setIsAuth(true);
      await checkAuth(); // Actualizar la información del usuario
      return response;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(null);
      setIsAuth(false);
      // window.location.href = '/login';
    }
  };

const checkAuth = async () => {
    try {
        const response = await api.get('/api/get_user');
        const sub = await getSubscribeCurrentPlan()
        if (response.data.user) {
            setUser({
                email: response.data.user.email,
                first_name: response.data.user.first_name,
                last_name: response.data.user.last_name,
                username: response.data.user.username,
                subscription: sub ? {
                    id: sub.id,
                    name: sub.plan.name,
                } : undefined

            });
            setIsAuth(true);
            return response.data.user;
        }
    } catch (error) {
        console.error('Error en checkAuth:', error);
        setAuthToken(null); // Asegurar limpieza del token inválido
        setUser(null);
        setIsAuth(false);
        return null;
    }
};

  return (
    <AuthContext.Provider value={{ isAuth, user, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);